
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recap/2025",
      function () {
        return require("private-next-pages/recap/2025.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recap/2025"])
      });
    }
  